import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { CreditCard, Palette, Users, Shield } from 'lucide-react';
import { cn } from '../../lib/utils';
import Billing from './Billing';
import Branding from './Branding';
import Team from './Team';
import Privacy from './Privacy';

const TABS = ['billing', 'branding', 'team', 'privacy'] as const;
type Tab = typeof TABS[number];

const Settings = () => {
  const { t } = useTranslation('billing');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = (searchParams.get('tab') as Tab) || 'billing';

  const setTab = (tab: Tab) => {
    setSearchParams({ tab });
  };

  const tabConfig: { id: Tab; label: string; icon: React.ReactNode }[] = [
    { id: 'billing', label: t('page_title'), icon: <CreditCard className="h-4 w-4" /> },
    { id: 'branding', label: t('branding_title'), icon: <Palette className="h-4 w-4" /> },
    { id: 'team', label: t('team_title'), icon: <Users className="h-4 w-4" /> },
    { id: 'privacy', label: t('privacy_title', { defaultValue: 'Privacy' }), icon: <Shield className="h-4 w-4" /> },
  ];

  return (
    <div className="flex flex-col h-full overflow-auto">
      {/* Tab Navigation */}
      <div className="border-b mb-6">
        <nav className="flex gap-1">
          {tabConfig.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setTab(tab.id)}
              className={cn(
                'flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors',
                activeTab === tab.id
                  ? 'border-primary text-primary'
                  : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
              )}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      {activeTab === 'billing' && <Billing />}
      {activeTab === 'branding' && <Branding />}
      {activeTab === 'team' && <Team />}
      {activeTab === 'privacy' && <Privacy />}
    </div>
  );
};

export default Settings;
